import request from "@/utils/request";

// --- 登录相关 ---

// 发送短信验证码
export function sendSms(phone) {
  return request({
    url: "/login/SendBindMobileSms",
    method: "post",
    // 【关键修改】根据文档 ，短信接口使用不同的根地址 (eno)
    baseURL: "https://eno.onechatai.cn/api",
    data: { phone },
  });
}

// 手机号登录
export function phoneLogin(data) {
  return request({
    url: "/login/PhoneLogin",
    method: "post",
    data, // { phone, smsCode }
  });
}

// --- 用户相关 ---

// 获取用户信息
export function getUserInfo() {
  return request({
    url: "/user/userInfo",
    method: "get",
  });
}

// --- 专注计时相关 ---

// 开始专注
export function startFocus() {
  return request({
    url: "/user/StartFocus",
    method: "post",
  });
}

// 专注心跳上报
export function pingFocus(sessionId) {
  return request({
    url: "/user/PingFocus",
    method: "post",
    data: { session_id: sessionId },
  });
}

// 完成专注
export function finishFocus(sessionId) {
  return request({
    url: "/user/FinishFocus",
    method: "post",
    data: { session_id: sessionId },
  });
}

// --- 订单与商品 ---

// 商品列表
export function getGoodsList() {
  return request({
    url: "/order/goods/list",
    method: "get",
  });
}

// 创建订单
export function createOrder(data) {
  return request({
    url: "/order/CreateOrder",
    method: "post",
    data, // { payment_way, payment_product, goods_id }
  });
}
